"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchEventPenaltyShootout_KickType = exports.MatchEventGoal_GoalEventType = exports.MatchEventCard_CardType = exports.protobufPackage = void 0;
exports.protobufPackage = "match_events";
var MatchEventCard_CardType;
(function (MatchEventCard_CardType) {
    MatchEventCard_CardType[MatchEventCard_CardType["YELLOW"] = 0] = "YELLOW";
    MatchEventCard_CardType[MatchEventCard_CardType["SECOND_YELLOW"] = 1] = "SECOND_YELLOW";
    MatchEventCard_CardType[MatchEventCard_CardType["RED"] = 2] = "RED";
    MatchEventCard_CardType[MatchEventCard_CardType["RETRACTED_RED"] = 3] = "RETRACTED_RED";
    MatchEventCard_CardType[MatchEventCard_CardType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MatchEventCard_CardType || (exports.MatchEventCard_CardType = MatchEventCard_CardType = {}));
var MatchEventGoal_GoalEventType;
(function (MatchEventGoal_GoalEventType) {
    MatchEventGoal_GoalEventType[MatchEventGoal_GoalEventType["GOAL"] = 0] = "GOAL";
    MatchEventGoal_GoalEventType[MatchEventGoal_GoalEventType["OWN_GOAL"] = 1] = "OWN_GOAL";
    MatchEventGoal_GoalEventType[MatchEventGoal_GoalEventType["PENALTY_GOAL"] = 2] = "PENALTY_GOAL";
    MatchEventGoal_GoalEventType[MatchEventGoal_GoalEventType["RETRACTED_GOAL"] = 3] = "RETRACTED_GOAL";
    MatchEventGoal_GoalEventType[MatchEventGoal_GoalEventType["MISSED_PENALTY_GOAL"] = 4] = "MISSED_PENALTY_GOAL";
    MatchEventGoal_GoalEventType[MatchEventGoal_GoalEventType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MatchEventGoal_GoalEventType || (exports.MatchEventGoal_GoalEventType = MatchEventGoal_GoalEventType = {}));
var MatchEventPenaltyShootout_KickType;
(function (MatchEventPenaltyShootout_KickType) {
    MatchEventPenaltyShootout_KickType[MatchEventPenaltyShootout_KickType["MISS"] = 0] = "MISS";
    MatchEventPenaltyShootout_KickType[MatchEventPenaltyShootout_KickType["GOAL"] = 1] = "GOAL";
    MatchEventPenaltyShootout_KickType[MatchEventPenaltyShootout_KickType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MatchEventPenaltyShootout_KickType || (exports.MatchEventPenaltyShootout_KickType = MatchEventPenaltyShootout_KickType = {}));
//# sourceMappingURL=match_events.js.map